/**
 * Created by glenn on 6/12/2017.
 */
import Redux = require("redux");
import {iRoad} from 'webmapsjs/dist/api/_npmrdsInterfaces';
import * as api from 'webmapsjs/dist/api/npmrds';
import * as actions from './actions';

let showAction = false;

export const npmrdsVersions = ['1', '2'];

function showActionMessage(msg: string) {
    if (showAction) {
        console.log(msg);
    }
}

interface iSetRoadIndex extends Redux.Action {
    roadIndex: number;
}

interface iStartEndDate extends Redux.Action {
    start: Date;
    end: Date;
    version: number;
}

interface iSetRoads extends Redux.Action {
    roads: iRoad[];
}

interface iUseBox extends Redux.Action {
    useBox: boolean;
}

interface iIsCsv extends Redux.Action {
    isCsv: boolean;
}

interface iSetVersion extends Redux.Action{
    version: string;
}

function version(state: number = parseInt(npmrdsVersions[1]), action: iSetVersion){
    if (action.type == actions.ACTION_SET_VERSION){
        return action.version;
    } else {
        return state;
    }
}

export function waiting(state: boolean = false, action: Redux.Action){
    if (action.type == actions.ACTION_SET_WAITING){
        return action['waiting'];
    } else {
        return state;
    }
}

function roadFilter(state: boolean = true, action: Redux.Action) {
    if (action.type == actions.ACTION_SET_ROAD_FILTER) {
        return !state;
    } else {
        return state;
    }
}

function csv(state: boolean = false, action: iIsCsv) {
    if (action.type == actions.ACTION_SET_IS_CSV) {
        return action.isCsv;
    } else {
        return state;
    }
}

function useBox(state: boolean = false, action: iUseBox) {

    if (action.type == actions.ACTION_SET_USE_BOX && action.useBox != state) {
        return action.useBox;
    } else {
        return state;
    }
}

export function roadIndex(state: number = null, action: iSetRoadIndex) {

    if (action.type == actions.ACTION_SET_ROAD_INDEX) {
        return action.roadIndex;
    } else {
        return state;
    }
}

export function startEndDate(state: { start: Date, end: Date, version: number } = {start: null, end: null, version: null}, action: iStartEndDate) {

    if (action.type == actions.ACTION_START_END_DATE) {
        if (state.start == action.start && state.end == action.end) {
            return state;
        } else {
            return {start: action.start, end: action.end, version: action.version};
        }
    } else {
        return state;
    }
}

function roads(state = [], action: iSetRoads) {
    if (action.type == actions.ACTION_SET_ROADS) {
        return action.roads;
    } else {
        return state;
    }
}

export const store = Redux.createStore(
    Redux.combineReducers({extent, roadIndex, roads, startEndDate, useBox, csv, roadFilter, version, waiting})
);

let setCoords = setCoordinatesClosure(store as Redux.Store<iExtent>);

export function setCoordinatesClosureStoreRef(coords: Array<number[]>) {

    showActionMessage("setCoordinatesClosureStoreRef");
    setRoadIndex(null);
    setCoords(coords);
}

export function setRoadIndex(roadIndex: number) {
    showActionMessage("setRoadDirection");
    store.dispatch({type: actions.ACTION_SET_ROAD_INDEX, roadIndex: roadIndex});
}

export function setRoads(roads: iRoad[]) {
    store.dispatch({type: actions.ACTION_SET_ROADS, roads: roads});

    if (roads && roads.length > 0) {
        setRoadIndex(0);
    } else {
        setRoadIndex(null);
    }
}

export function setUseBox(useBox: boolean) {
    store.dispatch({type: actions.ACTION_SET_USE_BOX, useBox: useBox});
}

export function setIsCsv(isCsv: boolean) {
    store.dispatch({type: actions.ACTION_SET_IS_CSV, isCsv: isCsv});
}

export function toggleRoadFilter() {
    return {type: actions.ACTION_SET_ROAD_FILTER};
}

export function getTmcs(roads: iRoad[], roadIndex: number, filter: boolean): string[] {
    let tmcList: string[] = [];

    if (filter && roadIndex != null) {
        return roads[roadIndex].tmcs;
    } else {
        for (let r of roads){
            tmcList.push(...r.tmcs as string[]);
        }
    }
    return tmcList;
}

interface iChangeCoordinates extends Redux.Action {
    coords: Array<number[]>;
}

function makeDefaultExtent() {
    return {coordinates: [], corners: {minX: null, minY: null, maxX: null, maxY: null}, set: false};
}

export function extent(state: { coordinates: Array<number[]>, corners: { minX: number, minY: number, maxX: number, maxY: number } } = makeDefaultExtent(),
                       action: iChangeCoordinates) {

    if (action.type == actions.ACTION_COORDINATES) {
        if (action.coords == null || action.coords.length < 3) {
            return makeDefaultExtent();
        }

        let xMin = 10E10;
        let yMin = 10E10;
        let xMax = -10E10;
        let yMax = -10E10;

        for (let a of action.coords) {
            xMin = a[0] < xMin ? a[0] : xMin;
            yMin = a[1] < yMin ? a[1] : yMin;
            xMax = a[0] > xMax ? a[0] : xMax;
            yMax = a[1] > yMax ? a[1] : yMax;
        }
        return {coordinates: action.coords, corners: {xMin: xMin, yMin: yMin, xMax: xMax, yMax: yMax}, set: true};
    } else {
        return state;
    }
}

export interface iExtentInner {
    coordinates: Array<number[]>,
    corners: {
        xMin: number,
        xMax: number,
        yMin: number,
        yMax: number
    },
    set: boolean
}

export interface iExtent {
    extent: iExtentInner
}

export interface iSetStoreCoordinates {
    dispatch: (a: { type: string, coords: Array<number[]> }) => any
}

export function setCoordinatesClosure(s: iSetStoreCoordinates): (coords: Array<number[]>) => any {
    return function (coords: Array<number[]>) {
        s.dispatch({type: actions.ACTION_COORDINATES, coords: coords});
    }
}

export function setCoordinates(coords: Array<number[]>){
    store.dispatch({type: actions.ACTION_COORDINATES, coords: coords});
}

export function updateRoads() {
    let s = getState();

    if (s.extent.coordinates.length < 4){
        return;
    }

    store.dispatch({type: actions.ACTION_SET_WAITING, waiting: true});

    api.getRoads({coordinates: s.extent.coordinates}, s.startEndDate.version, (d) => {
        if (d['error']) {
            setRoads([]);
        } else {
            setRoads(d.roads);
        }
        store.dispatch({type: actions.ACTION_SET_WAITING, waiting: false});
    }, (e) => {
        alert(e);
        // console.log(e);
        store.dispatch({type: actions.ACTION_SET_WAITING, waiting: false})
    });
}

export interface iState {
    extent: { coordinates: Array<number[]>, corners: { xMin: number, xMax: number, yMin: number, yMax: number }, set: boolean };
    roads: iRoad[];
    roadIndex: number;
    showFreeSpeed: boolean;
    useBox: boolean;
    startEndDate: { start: Date, end: Date, version: number };
    csv: boolean;
    roadFilter: boolean;
    waiting: boolean;
}

export function getState(): iState {
    return store.getState() as iState;
}

export default store;
